/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acc_Type_NfpInputs */

const en_acc_type_nfp = /** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Profit / Church`)
};

const es_acc_type_nfp = /** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ONG / Iglesia`)
};

const fr_acc_type_nfp = /** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Association / Église`)
};

const de_acc_type_nfp = /** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinnützig / Kirche`)
};

const id_acc_type_nfp = /** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Profit / Organisasi Keagamaan`)
};

/** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */
const ja_acc_type_nfp = en_acc_type_nfp;

/** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */
const zh_acc_type_nfp = en_acc_type_nfp;

/** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */
const ar_acc_type_nfp = en_acc_type_nfp;

/** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */
const it_acc_type_nfp = en_acc_type_nfp;

/** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */
const ru_acc_type_nfp = en_acc_type_nfp;

/** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */
const pt_acc_type_nfp = en_acc_type_nfp;

/** @type {(inputs: Acc_Type_NfpInputs) => LocalizedString} */
const ko_acc_type_nfp = en_acc_type_nfp;

/**
* | output |
* | --- |
* | "Non-Profit / Church" |
*
* @param {Acc_Type_NfpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acc_type_nfp = /** @type {((inputs?: Acc_Type_NfpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acc_Type_NfpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acc_type_nfp(inputs)
	if (locale === "es") return es_acc_type_nfp(inputs)
	if (locale === "fr") return fr_acc_type_nfp(inputs)
	if (locale === "de") return de_acc_type_nfp(inputs)
	if (locale === "ja") return ja_acc_type_nfp(inputs)
	if (locale === "zh") return zh_acc_type_nfp(inputs)
	if (locale === "ar") return ar_acc_type_nfp(inputs)
	if (locale === "id") return id_acc_type_nfp(inputs)
	if (locale === "it") return it_acc_type_nfp(inputs)
	if (locale === "ru") return ru_acc_type_nfp(inputs)
	if (locale === "pt") return pt_acc_type_nfp(inputs)
	return ko_acc_type_nfp(inputs)
});